import { useQueryClient } from '@tanstack/react-query';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { RegisterForm } from '@web/modules/auth/register-form';

export interface RegisterSearch {
  /** Invite code from the link printed by `npm run invite:create`. */
  invite?: string | undefined;
}

export const Route = createFileRoute('/_auth/register')({
  validateSearch: (search: Record<string, unknown>): RegisterSearch =>
    typeof search['invite'] === 'string' ? { invite: search['invite'] } : {},
  component: RegisterRoute,
});

function RegisterRoute() {
  const { invite } = Route.useSearch();
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  return (
    <RegisterForm
      invite={invite}
      onAuthenticated={async () => {
        queryClient.removeQueries({ queryKey: ['auth'] });
        await navigate({ to: '/', replace: true });
      }}
    />
  );
}
